<api-error-alert [apiError]="errorContext.error$ | async" (resetError)="errorContext.resetError()"></api-error-alert>